import uiEn from './i18n/en/ui.js'
import permissionsEn from './i18n/en/permissions.js'
import routes from './routes/routes.js'
import leftMenuConfig from './menus/left.js'
import { homeDestination } from './navigation.js'

export default ({ addLeftMenuItem, addTranslations, addPermissionTranslations, registerLoginRedirect, router }) => {
  addTranslations('en', uiEn, 'holidaysPublic')
  addTranslations('en', { concepts: { support_reply: { singular: 'reply', plural: 'replies', title: 'Replies' } } }, 'notes')
  addPermissionTranslations('en', permissionsEn)

  routes.forEach(route => {
    router.addRoute(route)
  })

  registerLoginRedirect(() => homeDestination)

  if (leftMenuConfig.items) {
    leftMenuConfig.items.forEach(item => {
      addLeftMenuItem(item)
    })
  }
}
